import { IIconProps } from "@/models";
import { SvgIcon } from "@mui/material";
import { memo } from "react";

const MessageQuestionIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 24 25"
      sx={{ fontSize: "inherit", fill: "none", ...sx }}
      {...otherProps}
    >
      <path
        d="M8 9.32532H16M8 13.3253H14M14.5 18.8253L12 21.3253L9 18.3253H6C5.20435 18.3253 4.44129 18.0092 3.87868 17.4466C3.31607 16.884 3 16.121 3 15.3253V7.32532C3 6.52967 3.31607 5.76661 3.87868 5.204C4.44129 4.64139 5.20435 4.32532 6 4.32532H18C18.7956 4.32532 19.5587 4.64139 20.1213 5.204C20.6839 5.76661 21 6.52967 21 7.32532V11.8253M19 22.3253V22.3353M19 19.3253C19.4483 19.3239 19.8832 19.1721 20.235 18.8943C20.5868 18.6164 20.8352 18.2286 20.9406 17.7928C21.0459 17.3571 21.0019 16.8986 20.8158 16.4908C20.6297 16.0829 20.3122 15.7493 19.914 15.5433C19.5162 15.3395 19.0611 15.2763 18.6228 15.364C18.1845 15.4517 17.7888 15.6851 17.5 16.0263"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default memo(MessageQuestionIcon);
